import { Application, Controller } from '@hotwired/stimulus';

const app = Application.start();

app.debug = process.env.NODE_ENV !== 'production';

app.register('random-text', class RandomText extends Controller {
  static targets = ['text'];
  static values = {
    texts: {
      default: [],
      type: Array,
    },
  };

  connect() {
    this.count = 0;
  }

  next() {
    this.textTarget.innerHTML = this.textsValue[this.count];
    this.count = (this.count + 1) % this.textsValue.length;
  }
});
